import { render } from "./TeamAvatarAndName.vue?vue&type=template&id=d79e81da&ts=true"
import script from "./TeamAvatarAndName.vue?vue&type=script&lang=ts"
export * from "./TeamAvatarAndName.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__